import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Commonmodel = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  onSubmit,
  submitLabel = "Save",
  showActions = true,
  disableBackdropClick = false, // NEW: control backdrop click behavior
  className,
}) => {

  // Handle close with reason check
  const handleClose = (event, reason) => {
    // If disableBackdropClick is true, only allow closing via CloseIcon
    if (disableBackdropClick && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return; // Don't close
    }
    onClose(event, reason);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      scroll="paper" // Enable internal scrolling
      className={className}
    >
      <div className="modal-header">
        <div>
          <DialogTitle className="tile-header">{title}</DialogTitle>
          {subtitle &&
            <h6 className="tile-subHeader">{subtitle}</h6>
          }
        </div>
        <IconButton onClick={() => handleClose()} className="Modelclose-btn">
  <CloseIcon />
</IconButton>
      </div>

      <DialogContent >{children}</DialogContent>

      {showActions && (
        <DialogActions>
         <Button onClick={() => handleClose()}>Cancel</Button>
          <Button variant="contained" onClick={onSubmit}>
            {submitLabel}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default Commonmodel;